import { render, staticRenderFns } from "./PopupPlsReset.vue?vue&type=template&id=4a4bb680&scoped=true"
import script from "./PopupPlsReset.vue?vue&type=script&lang=js"
export * from "./PopupPlsReset.vue?vue&type=script&lang=js"
import style0 from "./PopupPlsReset.vue?vue&type=style&index=0&id=4a4bb680&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4bb680",
  null
  
)

export default component.exports